import React, { useEffect } from "react";
import { initDateTimeComponentEditor } from "./DateTimeDataEditorJQueryInitializer";

interface DateTimeDataEditorProps {
  baseName: string;
  disabled: boolean;
  description: string;
  dateOnly: boolean;
  sideBySide: boolean;
  timestamp?: string;
}

export const DateTimeDataEditor = (props: DateTimeDataEditorProps) => {
  const { baseName, disabled, description, dateOnly, sideBySide, timestamp } = {
    ...props,
  };
  const [inputElement, setInputElement] = React.useState<HTMLInputElement>();

  useEffect(() => {
    if (inputElement) {
      initDateTimeComponentEditor(inputElement);
    }
  }, [inputElement]);

  return (
    <div className="flex space-x-3 post-component">
      <img
        src="/Content/Images/ic_datetime.png"
        className="groopit-component-icon-sm"
      />
      {/* position:relative is required for datetime picker to show up correctly */}
      <div className="flex-grow relative">
        <input
          type="hidden"
          name={`${baseName}.DateOnly`}
          value={dateOnly ? "true" : "false"}
        />
        <input
          type="hidden"
          className="target"
          name={`${baseName}.Timestamp`}
          value={timestamp ?? ""}
        />
        <label className="text-display-normal text-color-secondary">
          {description}
          <div>
            <input
              ref={(element) => setInputElement(element ?? undefined)}
              autoComplete="off"
              className="form-control datetime text-box single-line inline-block"
              data-date-allow-input-toggle="true"
              data-date-only={dateOnly ? "True" : "False"}
              data-date-side-by-side={sideBySide}
              aria-invalid="false"
              disabled={disabled}
            />
          </div>
        </label>
      </div>
    </div>
  );
};
